<!--
    TM-1000002000 · geändert 22.09.2026
    Consultant-Overlay eines Vorgangs: der Vorgang, in jeder Phase.

    Die frühere Fallunterscheidung (Skeleton bis zur Phasen-Antwort, danach reduzierte
    Vorgangsansicht ab „Erfasst") ist entfallen — dieselbe Entscheidung, die den Phasen-Guard von
    cw/case/:id und den /documents-Zweig des Zeilenklicks entfernt hat. Die Beschränkung sitzt am
    SCHRITT und wird vom Server durchgesetzt; ein gesperrter Schritt zeichnet seine Ersatzanzeige
    innerhalb des Vorgangs. Der Vorgang selbst wird dynamisch erzeugt (siehe Komponente), deshalb
    steht hier nur sein Anker.
-->
<ng-container #fullCaseHost></ng-container>
